module.exports = __webpack_public_path__ + "img/nex_img.203ecb36.svg";